export default "__VITE_ASSET__DuzY63Qh__"